import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=CRUNCHYROLL_ASIA_FREE_TRIAL_EXP:control
// ?preferred_variant=CRUNCHYROLL_ASIA_FREE_TRIAL_EXP:variant_1
// ?remove_preferred_experiment=CRUNCHYROLL_ASIA_FREE_TRIAL_EXP

export const CrunchyrollAsiaFreeTrialExpName = 'CRUNCHYROLL_ASIA_FREE_TRIAL_EXP' as const;

export type CrunchyrollAsiaFreeTrialExpVariants = ToVariants<typeof CrunchyrollAsiaFreeTrialExpVariants>;

export const CrunchyrollAsiaFreeTrialExpVariants = {
	/** Free Trial Feature on Crunchyroll + other Animation titles (same as US, UK, FR etc.) */
	CONTROL: 'control',
	/** No Free Trial Feature, same as prod */
	VARIANT_1: 'variant_1',
} as const;

export default generate(CrunchyrollAsiaFreeTrialExpName, CrunchyrollAsiaFreeTrialExpVariants);
